"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("./actions");
var lodash_1 = require("lodash");
var initState = {};
exports.default = (function (state, action) {
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case actions_1.ADD_PRODUCT:
            var quantity = action.product.quantity || 1;
            return __assign(__assign({}, (0, lodash_1.cloneDeep)(action.product)), { quantity: quantity });
        case actions_1.ADD_PRODUCT_QUANTITY:
            return __assign(__assign({}, state), { quantity: state.quantity + 1 });
        case actions_1.CHANGE_MODIFIER_STATE:
            var productModifiers = state.modifier_groups.map(function (category) {
                return __assign(__assign({}, category), { modifier_items: category.modifier_items.map(function (modifier) {
                        if (modifier.id === action.id) {
                            modifier.checked = action.checked;
                        }
                        if (action.categoryId === category.id && action.isRadio && modifier.id !== action.id) {
                            modifier.checked = false;
                        }
                        return modifier;
                    }) });
            });
            return __assign(__assign({}, state), { modifier_groups: productModifiers });
        case actions_1.ADD_MODIFIER_STATE_QUANTITY:
            return __assign(__assign({}, state), { modifier_groups: state.modifier_groups.map(function (category) {
                    return __assign(__assign({}, category), { modifier_items: category.modifier_items.map(function (item) {
                            if (item.id === action.id) {
                                var quantity_1 = item.quantity || 0;
                                item.quantity = quantity_1 + 1;
                                item.checked = item.quantity > 0;
                            }
                            return item;
                        }) });
                }) });
        case actions_1.REMOVE_MODIFIER_STATE_QUANTITY:
            return __assign(__assign({}, state), { modifier_groups: state.modifier_groups.map(function (category) {
                    return __assign(__assign({}, category), { modifier_items: category.modifier_items.map(function (item) {
                            if (item.id === action.id) {
                                var quantity_2 = item.quantity || 0;
                                item.quantity = quantity_2 - 1;
                                item.checked = item.quantity > 0;
                            }
                            return item;
                        }) });
                }) });
        case actions_1.REMOVE_PRODUCT_QUANTITY:
            return __assign(__assign({}, state), { quantity: state.quantity - 1 });
        case actions_1.CLEAR_PRODUCT:
            return initState;
        default:
            return state;
    }
});
